/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Header from "./header"
import Footer from "./footer"
import "../assets/stylesheets/layout.scss"
import {ThemeProvider} from 'styled-components'
import theme from '../assets/stylesheets/theme'
import HeaderImg from "./headerImg"
import { Helmet } from "react-helmet"

const Layout = ({ children, className, postList, here}) => {


  return (
    <ThemeProvider theme={theme}>
        <Helmet>
        <meta name="description" content="Portal de trámites online del Registro Civil de la Provincia de San Luis. Consulta los requisitos o saca turno para realizar tus trámites."/>
       <meta charSet="utf-8" />
        </Helmet>
      <HeaderImg/>
      <Header postList={postList} here={here}/>
      {/* <Header siteTitle={data.site.siteMetadata.title}/> */}
      <main >{children}</main>
      <Footer  className={className}/>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
